<div
  data-testid="offer-upsert-page"
  class="offer-upsert-container flex flex-col gap-4"
>
  <ng-template #offerConfigurationArrays>
    <div class="schema-array-configuration-append space-y-4">
      @for (def of schemaArrayFieldDefs(); track def.name) {
        <div class="schema-array-subsection" [attr.data-array-field]="def.name">
          <div class="flex items-center justify-between mb-3 gap-2">
            <h3 class="text-sm font-medium text-gray-800">
              {{ arraySectionTitle(def) }}
            </h3>
            <p-button
              [attr.data-testid]="
                'offer-upsert-schema-array-add-btn-' + def.name
              "
              type="button"
              [label]="'common.actions.add' | translate"
              icon="add"
              severity="info"
              size="small"
              styleClass="schema-array-add-button"
              (onClick)="addSchemaArrayRow(def.name, def.itemProperties)"
            />
          </div>
          @if (rowsForField(def.name).length > 0) {
            <div class="overflow-x-auto rounded border border-gray-200">
              <table
                [attr.data-testid]="'offer-upsert-schema-array-table-' + def.name"
                class="schema-array-table w-full text-sm border-collapse min-w-[640px]"
              >
                <thead>
                  <tr class="bg-gray-50 border-b border-gray-200">
                    @for (p of def.itemProperties; track p.name) {
                      <th
                        class="text-left p-2 font-medium text-gray-700 whitespace-nowrap"
                      >
                        {{ propHeaderLabel(p)
                        }}@if (isRequiredProp(p)) {<span class="text-red-500">&nbsp;*</span>}
                      </th>
                    }
                    <th class="w-12 p-2"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of rowsForField(def.name); track row.id) {
                    <tr class="border-b border-gray-100 hover:bg-gray-50/80">
                      @for (p of def.itemProperties; track p.name) {
                        <td class="p-1 align-middle">
                          @if (p.name && propCellKind(p) === "dropdown") {
                            <p-select
                              [attr.data-testid]="
                                'offer-upsert-schema-array-select-' +
                                def.name +
                                '-' +
                                row.id +
                                '-' +
                                p.name
                              "
                              [options]="cellDropdownOptions(p)"
                              optionLabel="label"
                              optionValue="value"
                              [ngModel]="row[p.name]"
                              (ngModelChange)="
                                patchSchemaArrayCell(
                                  def.name,
                                  row.id,
                                  p.name!,
                                  $event
                                )
                              "
                              [placeholder]="propHeaderLabel(p)"
                              appendTo="body"
                              styleClass="w-full text-sm max-w-[14rem]"
                            />
                          } @else if (p.name && propCellKind(p) === "number") {
                            <p-inputNumber
                              [attr.data-testid]="
                                'offer-upsert-schema-array-number-' +
                                def.name +
                                '-' +
                                row.id +
                                '-' +
                                p.name
                              "
                              [ngModel]="row[p.name]"
                              (ngModelChange)="
                                patchSchemaArrayCell(
                                  def.name,
                                  row.id,
                                  p.name!,
                                  $event
                                )
                              "
                              [min]="cellNumberMin(p)"
                              [max]="cellNumberMax(p)"
                              [showButtons]="false"
                              styleClass="w-full text-sm schema-array-num-input"
                            />
                          } @else if (p.name) {
                            <input
                              [attr.data-testid]="
                                'offer-upsert-schema-array-input-' +
                                def.name +
                                '-' +
                                row.id +
                                '-' +
                                p.name
                              "
                              pInputText
                              class="w-full text-sm max-w-[16rem]"
                              [ngModel]="row[p.name]"
                              (ngModelChange)="
                                patchSchemaArrayCell(
                                  def.name,
                                  row.id,
                                  p.name!,
                                  $event
                                )
                              "
                              [placeholder]="propHeaderLabel(p)"
                            />
                          }
                        </td>
                      }
                      <td class="p-1 text-right">
                        <p-button
                          [attr.data-testid]="
                            'offer-upsert-schema-array-delete-btn-' +
                            def.name +
                            '-' +
                            row.id
                          "
                          type="button"
                          icon="pi pi-trash"
                          [text]="true"
                          severity="danger"
                          (onClick)="removeSchemaArrayRow(def.name, row.id)"
                        />
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>

  <app-add-form
    data-testid="offer-upsert-add-form"
    #addForm
    [title]="
      editMode
        ? ('offer.form.edit.title' | translate)
        : ('offer.form.add.title' | translate)
    "
    [formFields]="formFields()"
    [headerActions]="headerActions"
    [editMode]="editMode"
    [initialData]="initialData()"
    [loading]="loading()"
    [enableOverflow]="false"
    [showScopeLinesInPeriodicSection]="false"
    [showScopeLinesInMixMatchSection]="false"
    [showMultibuyTiersInSection]="false"
    [configurationAppendTemplate]="
      showConfiguration() ? offerConfigurationArrays : null
    "
    (formAction)="onFormAction($event.action, $event.data)"
    (formValueChanges)="onFormValueChanges($event)"
  ></app-add-form>

  <p-toast data-testid="offer-upsert-toast"></p-toast>
</div>
